import { View, StyleSheet } from 'react-native';
import { ErrorBoundary as ErrorBoundaryLib, ErrorBoundaryProps } from 'react-error-boundary';
import { SafeAreaView } from 'react-native-safe-area-context';

import { spacing } from '../../theme';
import { Button } from '../Button';
import { Text } from '../Text';
import { refresh } from './refresh';
import i18n from '../../i18n';

export const ErrorBoundary = ({
	children,
	...props
}: Omit<ErrorBoundaryProps, 'fallbackRender' | 'FallbackComponent'>) => {
	const { t } = i18n;

	return (
		<ErrorBoundaryLib
			fallback={
				<SafeAreaView style={styles.fallbackContainer}>
					<View style={styles.titles}>
						<Text align="center" category="h1">
							{t('error-boundary.whoops-something-went-wrong')}
						</Text>
						<Text align="center" category="s1">
							{t('error-boundary.please-either-refresh-the-page-or-try-again-later')}
						</Text>
					</View>

					<Button color="primary" variant="filled" onPress={refresh} style={styles.button}>
						{t('error-boundary.refresh')}
					</Button>
				</SafeAreaView>
			}
			{...props}
		>
			{children}
		</ErrorBoundaryLib>
	);
};

const styles = StyleSheet.create({
	fallbackContainer: {
		alignItems: 'center',
		marginTop: spacing(2),
		padding: spacing(4),
		gap: spacing(5),
	},
	titles: { gap: spacing() },
	button: { maxWidth: 200 },
});
